/* eslint-disable @typescript-eslint/no-empty-function */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { City, Currency, Language, RateType, SeoTags, Speciality } from '../../../base/interfaces/config';

export interface EmployerAppState {
    initialized: boolean;
    config: Config;
    citySearchOptions: City[] | null;
    specialitySearchOptions: Speciality[] | null;
}

export interface Config {
    currency: Currency[];
    language: Language[];
    rateType: RateType[];
    seo: SeoTags;
}

export interface ConfigUpdateParams {
    currency?: Currency[];
    language?: Language[];
    rateType?: RateType[];
    seo?: SeoTags;
}

const seoTagsInitialState = {
    title: '',
    description: '',
};

const initialState: EmployerAppState = {
    initialized: false,
    config: {
        currency: [],
        language: [],
        rateType: [],
        seo: seoTagsInitialState,
    },
    citySearchOptions: null,
    specialitySearchOptions: null,
};

export const employerAppSlice = createSlice({
    name: 'employer-app',
    initialState,
    reducers: {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        init: () => {},
        setInitialized: (state, action: PayloadAction<boolean>) => {
            state.initialized = action.payload;
        },
        getConfig: () => {},
        setConfig: (state, action: PayloadAction<ConfigUpdateParams>) => {
            state.config = {
                ...state.config,
                ...action.payload,
            };
        },
        specialitySearchRequest: {
            reducer: () => {},
            prepare: (search: string) => ({ payload: search }),
        },
        specialitySearchSuccess: (state, action: PayloadAction<Speciality[] | null>) => {
            state.specialitySearchOptions = action.payload;
        },
        citySearchRequest: {
            reducer: () => {},
            prepare: (search: string) => ({ payload: search }),
        },
        citySearchSuccess: (state, action: PayloadAction<City[] | null>) => {
            state.citySearchOptions = action.payload;
        },
    },
});

export const employerAppActions = employerAppSlice.actions;
export const employerAppReducer = employerAppSlice.reducer;
